var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"kontainer"},[_c('div',{attrs:{"id":"button-container"}},[_c('button',{attrs:{"onclick":"test()"}},[_vm._v("Run Test")])]),_c('div',{attrs:{"id":"animation-target"}}),_c('iframe',{attrs:{"id":"iframe"}})])])
}]

export { render, staticRenderFns }